import { Box, Typography } from "@mui/material";
import Player from 'lottie-react';
import loadingAnimation from '../files/json/loading-animation.json';

interface LoadingOverlayProps {
    title?: string;
    message?: string;
    isLoading: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ title, message, isLoading }) => {
    return (
        <Box
            position="fixed"
            top={0}
            left={0}
            width="100vw"
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
            bgcolor="rgba(255, 255, 255, 0.71)"
            zIndex={1300}
            visibility={isLoading ? 'visible' : 'hidden'}
        >
            <Box 
                sx={{ 
                    p: 4, 
                    color: 'red', 
                    textAlign: 'center', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                    boxSizing: 'border-box',
                }}
            >
                <Player
                    autoplay
                    loop
                    animationData={loadingAnimation}
                    style={{ height: 100, width: 100 }}
                />
                <Typography color="primary" fontSize={18}>
                    {title}
                </Typography>
                <Typography variant="body2" fontSize={14} color="text.secondary">
                    {message}
                </Typography>
            </Box> 
        </Box>
    );
};

export default LoadingOverlay;
